import React, { useState } from 'react'
import Classes from '../MainLayout.module.css'
import ProfileDropDown from '../ProfileDropDown'
import { useLocation } from 'react-router-dom';
import convertToRgba from '../../../../utils/colorUtils';
import { useEffect } from 'react';
import Notifications from '../../../GlobalComponents/Notification/Notifcation';
import { Switch, FormControlLabel } from "@mui/material";

const MenuIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" height='20px' viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z" /></svg>
)

export default function Header({ setopenMobileSidebar, isMobile, showAgencyRoutes, setShowAgencyRoutes }) {
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    function formatPageTitle(pathname) {
        // If it's just "/", return "Dashboard"
        if (pathname === '/') return 'Dashboard';
        // Remove leading slash
        let cleanPath = pathname.slice(1);
        // Replace all dashes with spaces
        cleanPath = cleanPath.replace(/-/g, ' ');
        // Capitalize the first character
        return cleanPath.charAt(0).toUpperCase() + cleanPath.slice(1);
    }

    const [copied, setCopied] = useState(false);
    const handleCopyText = () => {
        // const textToCopy = `${onBoarding.companyName}.evala.ai`;
        const textToCopy = `evala.ai`;
        navigator.clipboard.writeText(textToCopy).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset copied state after 2 seconds
        });
    };

    return (
        <>
            <header className={Classes.navbar}  >
                {isMobile ?
                    <div onClick={() => { setopenMobileSidebar(true) }} className='flexAlign10' >
                        <div> <MenuIcon /> </div>
                        <h4> {formatPageTitle(location?.pathname)} </h4>
                    </div>
                    :
                    activePage === '/' ?
                        <div>
                            <h4> Hello, Anchorize! </h4>
                        </div>
                        : <div></div>
                }
                {activePage === '/' &&
                    <div className={Classes.flexAlign} >
                        <div className={Classes.bannerMid} >
                            <div className={Classes.bmLeft} >
                                <h5>Agency</h5>
                            </div>
                            <div className={Classes.bmRight} style={{ background: convertToRgba('#3e9bff', 0.10) }} >
                                <h5>.anchorize.io</h5>
                            </div>
                        </div>
                        {copied ?
                            <svg xmlns="http://www.w3.org/2000/svg" height="17px" width="17px" viewBox="0 0 448 512"><path fill="#000000" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
                            :
                            <svg onClick={handleCopyText} xmlns="http://www.w3.org/2000/svg" height="17px" width="17px" cursor="pointer" viewBox="0 0 448 512"><path d="M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z" /></svg>
                        }
                    </div>
                }
                <div className={Classes.headerRight} >
                    <div className='toggleCon' >
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={showAgencyRoutes}
                                    onChange={() => setShowAgencyRoutes((prev) => !prev)}
                                />
                            }
                            label={showAgencyRoutes ? "Agency View" : "Client View"}
                        />
                    </div>
                    <Notifications />
                    <div className={Classes.verticleLine} ></div>
                    <div className={Classes.profileSection}>
                        <ProfileDropDown />
                    </div>
                </div>
            </header>
        </>
    )
}
